import React from 'react';

import styles from '@lmt/unicorn-shared/src/app/components/common/ui-kit/configuration/SettingsSeparatorLine.module.scss';

export const SettingsSeparatorLine: React.FC = () => {
  return <div className={styles.separator} />;
};
